import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { useTranslation } from 'react-i18next';

type MessageActionType = {
    icon: IconProp;
    label: string;
};

interface MessageProps {
    message: string;
    showActions?: boolean;
}

interface MessageActionButtonsProps {
    actions: MessageActionType[];
    variant: 'sent' | 'received';
}


const FeedbackMessage = ({ message, showActions = true }: MessageProps) => {

    const { t } = useTranslation();

    const formatText = (text: string) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    return (
        <>
            <h3 className="mb-2">{t("FeedbackMessage.job_skills_comment")}</h3>
            {message && <p className="mb-0 fs-8">{formatText(message)}</p>}
        </>
    );
};

export default FeedbackMessage;
